/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_GoogleInputs */

const en_auth_signup_google = /** @type {(inputs: Auth_Signup_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up with Google`)
};

const pl_auth_signup_google = /** @type {(inputs: Auth_Signup_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarejestruj się przez Google`)
};

/**
* | output |
* | --- |
* | "Sign up with Google" |
*
* @param {Auth_Signup_GoogleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_google = /** @type {((inputs?: Auth_Signup_GoogleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_GoogleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_google(inputs)
	return en_auth_signup_google(inputs)
});